/**
 * Avada Pixel Blocker v1.7
 * Changes from v1.6: added _tb_ prefix to block Trackbee cookies
 *   (_tb_google_booster_config, _tb_latest_consent_update,
 *    _tb_personalization_consent, _tb_user_data_consent, ...)
 */
(function() {
  'use strict';
  
  if (window.__avadaPixelBlockerActive) return;
  window.__avadaPixelBlockerActive = true;
  
  var DEBUG = true;  // ← auf false setzen sobald verifiziert
  
  var RISKY_PIXEL_IDS = ['311984466'];
  
  var BLOCKED_COOKIES = [
    '_gcl_au', '_gcl_aw', '_gcl_dc',
    '_ga', '_ga_C45C9665W1',
    '_fbp', '_fbc',
    '_ttp', '_tt_enable_cookie', 'ttcsid',
    '_uetvid', '_uetsid',
    '_pin_unauth'
  ];
  
  var BLOCKED_COOKIE_PREFIXES = [
    'ig-', 'ig_',
    'ttcsid_',         // dynamische TikTok Pixel-IDs
    '_ga_',            // weitere GA4 Properties
    '_tb_'             // Trackbee (google_booster_config, latest_consent_update,
                       // personalization_consent, user_data_consent, ...)
  ];
  
  var CLEANUP_INTERVAL_MS = 1000;
  
  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[blocker]'].concat([].slice.call(arguments)));
  }
  
  function getMarketingConsent() {
    try {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf('avada_cookie_consent=') === 0) {
          var raw = decodeURIComponent(c.substring('avada_cookie_consent='.length));
          return !!JSON.parse(raw).marketing;
        }
      }
      return null;
    } catch (e) { return null; }
  }
  
  function shouldBlock() { return getMarketingConsent() !== true; }
  
  function cookieExists(name) {
    return document.cookie.split(';').some(function(c) {
      return c.trim().indexOf(name + '=') === 0;
    });
  }
  
  function getCookieDomainVariants() {
    var host = location.hostname;
    // Fallback-Liste, *immer* inkl. expliziter Apex-Notation
    var variants = [
      '',                                    // host-only
      '; domain=' + host,                    // exact: nl.mothersearth.com
      '; domain=.' + host                    // .nl.mothersearth.com
    ];
    
    // Parent-Domains hochlaufen — explizit, kein Off-by-one Risiko
    var parts = host.split('.');
    while (parts.length > 2) {  // stop bei eTLD+1 (mothersearth.com)
      parts.shift();
      var parent = parts.join('.');
      variants.push('; domain=' + parent);
      variants.push('; domain=.' + parent);
    }
    
    return variants;
  }
  
  function deleteCookie(name) {
    var existedBefore = cookieExists(name);
    if (!existedBefore) return;
    
    log(name + ': present BEFORE delete');
    
    var domains = getCookieDomainVariants();
    // Path-Varianten — manche Vendoren setzen path=/, andere ohne path-Attribut
    var paths = ['; path=/', '; path=/;', ''];
    
    for (var i = 0; i < domains.length; i++) {
      for (var j = 0; j < paths.length; j++) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + paths[j] + domains[i];
      }
    }
    
    log(name + (cookieExists(name) ? ': STILL PRESENT after delete ✗' : ': GONE after delete ✓'));
  }
  
  function cleanupAllBlockedCookies() {
    if (!shouldBlock()) return;
    
    BLOCKED_COOKIES.forEach(deleteCookie);
    
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var name = cookies[i].trim().split('=')[0];
      if (!name) continue;
      for (var j = 0; j < BLOCKED_COOKIE_PREFIXES.length; j++) {
        if (name.indexOf(BLOCKED_COOKIE_PREFIXES[j]) === 0) {
          deleteCookie(name);
          break;
        }
      }
    }
  }
  
  // ============ IFRAME REMOVAL (unchanged) ============
  function isRiskyPixelIframe(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== 'IFRAME') return false;
    if (!node.id) return false;
    var match = node.id.match(/web-pixel-sandbox-(?:APP|CUSTOM)-(\w+)/);
    return !!match && RISKY_PIXEL_IDS.indexOf(match[1]) !== -1;
  }
  
  function removeIframe(node) {
    try { node.remove(); }
    catch (e) { try { node.parentNode && node.parentNode.removeChild(node); } catch (e2) {} }
  }
  
  function scanAndRemoveExistingIframes() {
    if (!shouldBlock()) return;
    var iframes = document.querySelectorAll('iframe[id*="web-pixel-sandbox"]');
    for (var i = 0; i < iframes.length; i++) {
      if (isRiskyPixelIframe(iframes[i])) removeIframe(iframes[i]);
    }
  }
  
  function startObserver() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function(mutations) {
      if (!shouldBlock()) return;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (isRiskyPixelIframe(nodes[j])) removeIframe(nodes[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  
  scanAndRemoveExistingIframes();
  startObserver();
  cleanupAllBlockedCookies();
  setInterval(function() { if (shouldBlock()) cleanupAllBlockedCookies(); }, CLEANUP_INTERVAL_MS);
})();